module.exports = __webpack_public_path__ + "static/media/gold-chips-big.8a42d6cd.png";